export default "__VITE_ASSET__BulwAm4$__"